module.exports = __webpack_public_path__ + "img/logo-blanco-experis.8b00b3bb.svg";